import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "saved-searches";

@Injectable({
  providedIn: "root",
})
export class SavedSearchesHandlerService {
  constructor(private APIService: ApiService) {}

  list(masterAccountID: number, accountAppID: number, type: string) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${accountAppID}?type=${type}`,
    );
  }

  create(masterAccountID: number, accountAppID: number, body: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppID}`, body);
  }

  update(masterAccountID: number, accountAppID: number, id: number, body: any) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${accountAppID}/${id}`,
      body,
    );
  }

  delete(masterAccountID: number, accountAppID: number, id: number) {
    return this.APIService.delete(
      `${PATH}/${masterAccountID}/${accountAppID}/${id}`,
    );
  }

  run(masterAccountID: number, accountAppID: number, id: number, body?: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/${accountAppID}/${id}/run`,
      body || {},
    );
  }
}


